import React from 'react'

const Support = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={40}
                height={40}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <ellipse
                        cx="246.23"
                        cy="279.97"
                        fill="#fedf30"
                        rx="207.4"
                        ry="207.378"
                        opacity={1}
                        data-original="#fedf30"
                    />
                    <path
                        fill="#fed402"
                        d="M310.977 82.913c43.326 38.009 70.685 93.773 70.685 155.933 0 114.532-92.856 207.378-207.4 207.378-22.612 0-44.373-3.632-64.747-10.321 36.503 32.023 84.338 51.445 136.715 51.445 114.544 0 207.4-92.846 207.4-207.378.001-91.922-59.819-169.862-142.653-197.057z"
                        opacity={1}
                        data-original="#fed402"
                    />
                    <ellipse
                        cx="246.23"
                        cy="279.97"
                        fill="#ffffff"
                        rx="169.684"
                        ry="169.666"
                        opacity={1}
                        data-original="#ffffff"
                        className="hovered-path"
                    />
                    <path
                        fill="#f8f6f6"
                        d="M366.073 159.86c10.039 24.347 15.59 51.016 15.59 78.986 0 104.644-77.521 191.17-178.27 205.332a169.984 169.984 0 0 0 42.838 5.458c93.714 0 169.684-75.962 169.684-169.666-.001-46.923-19.053-89.395-49.842-120.11z"
                        opacity={1}
                        data-original="#f8f6f6"
                    />
                    <path
                        fill="#fee97d"
                        d="M246.23 102.805c-97.699 0-177.184 79.477-177.184 177.166S148.53 457.137 246.23 457.137s177.185-79.476 177.185-177.166S343.93 102.805 246.23 102.805zm87.478 313.666-12.562-21.755a7.5 7.5 0 0 0-12.99 7.501l12.57 21.77c-22.32 11.59-47.655 18.15-74.496 18.15-26.861 0-52.213-6.57-74.546-18.176a7.41 7.41 0 0 0 .465-.693l12.154-21.05a7.501 7.501 0 0 0-2.745-10.246 7.5 7.5 0 0 0-10.245 2.745l-12.154 21.05a7.558 7.558 0 0 0-.368.73 163.474 163.474 0 0 1-49.106-49.103c.249-.11.498-.224.739-.364l21.047-12.15a7.5 7.5 0 0 0 2.745-10.245 7.498 7.498 0 0 0-10.245-2.745l-21.047 12.15a7.404 7.404 0 0 0-.702.463c-11.606-22.329-18.176-47.676-18.176-74.532 0-26.838 6.561-52.17 18.152-74.488l21.773 12.569a7.498 7.498 0 0 0 10.245-2.746 7.5 7.5 0 0 0-2.745-10.245l-21.756-12.559a163.49 163.49 0 0 1 49.037-49.032l12.561 21.755a7.498 7.498 0 0 0 10.245 2.745 7.5 7.5 0 0 0 2.745-10.246l-12.57-21.769c20.229-10.504 42.936-16.87 66.996-17.97v25.159c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-25.159c83.473 3.819 150.685 71.023 154.505 154.486h-25.163c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h25.163c-1.101 24.056-7.467 46.76-17.972 66.987l-21.774-12.569a7.498 7.498 0 0 0-10.245 2.746 7.5 7.5 0 0 0 2.745 10.245l21.756 12.559a163.476 163.476 0 0 1-49.036 49.032z"
                        opacity={1}
                        data-original="#fee97d"
                    />
                    <path
                        fill="#0593fc"
                        d="m116.62 263.92-38.08-38.08c-8.432-8.432-22.102-8.432-30.534 0-42.58 42.58-42.58 111.616 0 154.196l100.029 100.029c42.58 42.58 111.616 42.58 154.196 0 8.432-8.432 8.432-22.102 0-30.534l-38.08-38.08c-8.432-8.432-22.102-8.432-30.534 0l-12.306 12.306c-12.464 12.464-32.672 12.464-45.135 0l-71.861-71.861c-12.464-12.464-12.464-32.672 0-45.135l12.306-12.306c8.431-8.433 8.431-22.103-.001-30.535z"
                        opacity={1}
                        data-original="#0593fc"
                        className=""
                    />
                    <path
                        fill="#0182fc"
                        d="M288.256 435.556c-31.87 19.301-69.252 30.413-109.231 30.413-17.73 0-34.945-2.197-51.399-6.312l20.408 20.408c42.58 42.58 111.616 42.58 154.196 0 8.432-8.432 8.432-22.102 0-30.534z"
                        opacity={1}
                        data-original="#0182fc"
                    />
                    <path
                        fill="#00f2a6"
                        d="M348.287 221.356c-40.925-23.628-66.135-67.294-66.135-114.549v-39.73c0-4.535 2.419-8.725 6.347-10.993l94.196-54.383a12.695 12.695 0 0 1 12.693 0l94.196 54.383a12.694 12.694 0 0 1 6.347 10.993v39.731c0 47.256-25.211 90.922-66.135 114.549l-34.407 19.865a12.695 12.695 0 0 1-12.693 0z"
                        opacity={1}
                        data-original="#00f2a6"
                    />
                    <path
                        fill="#05e39c"
                        d="m489.583 56.084-55.34-31.95v59.422c0 47.256-25.211 80.641-66.135 104.268l-37.248 21.505a132.327 132.327 0 0 0 17.428 12.028l34.407 19.865a12.695 12.695 0 0 0 12.693 0l34.407-19.865c40.925-23.628 66.135-67.294 66.135-114.549V67.077a12.696 12.696 0 0 0-6.347-10.993z"
                        opacity={1}
                        data-original="#05e39c"
                    />
                    <path
                        fill="#ffffff"
                        d="M367.326 188.378a94.19 94.19 0 0 1-47.095-81.571V85.398a6.347 6.347 0 0 1 3.173-5.496l62.462-36.062a6.346 6.346 0 0 1 6.347 0l62.463 36.062a6.346 6.346 0 0 1 3.173 5.496v21.409a94.19 94.19 0 0 1-47.097 81.572l-18.54 10.704a6.344 6.344 0 0 1-6.346 0z"
                        opacity={1}
                        data-original="#ffffff"
                        className="hovered-path"
                    />
                    <path
                        fill="#f8f6f6"
                        d="m454.677 79.902-20.434-11.797v15.451c0 47.256-25.211 80.641-66.135 104.268l-.868.501.088.053 18.54 10.704a6.344 6.344 0 0 0 6.346 0l18.54-10.704a94.19 94.19 0 0 0 47.096-81.572V85.398a6.347 6.347 0 0 0-3.173-5.496z"
                        opacity={1}
                        data-original="#f8f6f6"
                    />
                    <path
                        fill="#05e39c"
                        d="M306.962 342.297h-.065a7.5 7.5 0 0 1-7.436-7.564c.068-7.852.137-16.544.2-25.458h-48.41a7.5 7.5 0 0 1-6.566-11.123c3.841-6.962 37.714-68.247 44.096-76.076 6.478-7.945 13.246-6.921 15.854-6.114 5.554 1.72 9.511 7.247 10.081 14.081.338 4.053.218 36.377.046 64.232h6.758c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5h-6.858c-.09 12.656-.174 22.599-.199 25.586a7.505 7.505 0 0 1-7.501 7.436zm-42.98-48.022h35.778c.175-28.458.262-55.681.058-61.938-4.717 6.633-22.301 37.615-35.836 61.938zM196.742 343.411c-21.214 0-22.711-.5-23.723-.838-2.573-.857-4.492-2.789-5.265-5.299-1.379-4.482.44-6.864 7.211-15.727 5.705-7.469 16.324-21.372 34.11-46.784 5.559-7.94 9.141-15.115 10.652-21.333l.438-3.426c-.236-11.447-9.623-20.687-21.128-20.687-10.077 0-18.798 7.16-20.735 17.025a7.498 7.498 0 0 1-8.805 5.914 7.5 7.5 0 0 1-5.914-8.805c3.315-16.882 18.227-29.135 35.454-29.135 19.924 0 36.133 16.208 36.133 36.129 0 .318-.021.636-.061.952l-.554 4.328c-.032.25-.076.497-.133.742-1.896 8.178-6.29 17.228-13.059 26.897-16.297 23.282-26.649 37.018-32.74 45.008 11.839.061 29.969-.067 43.693-.24a7.48 7.48 0 0 1 7.594 7.405 7.5 7.5 0 0 1-7.404 7.594c-15.824.201-27.347.28-35.764.28zM385.099 150.994a7.497 7.497 0 0 1-5.431-2.328l-25.387-26.656a7.5 7.5 0 0 1 10.864-10.345l19.764 20.753 30.126-33.892a7.5 7.5 0 0 1 11.211 9.965l-35.541 39.984a7.504 7.504 0 0 1-5.477 2.516c-.043.003-.086.003-.129.003z"
                        opacity={1}
                        data-original="#05e39c"
                    />
                </g>
            </svg>

        </>
    )
}

export default Support